// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__31MHB","label":"Completed_label__3Q0VY"};